export default {"src":"/_next/static/media/harpio.62105e4f.svg","height":103,"width":275,"blurWidth":0,"blurHeight":0};